module.exports = __webpack_public_path__ + "static/img/pic_phone_4.a1dff44.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/pic_phone_4.png
// module id = Zg2Q
// module chunks = 1